import { checkReturned, returnValue } from '../../components/utils/helper';
import { COMMANDBASEURL, QUERYBASEURL } from '../../constants/global';
import { type IUploadFileResponse } from '../../interface/IResult';
import { resultType } from '../types';
import * as utils from './utils';

export const getUnapprovedResultsAction = (pageSize?: number, pageNumber?: number, sort?: string) =>
	utils.httpGetMethod({
		apiData: {
			url: '',
			customurl:
				QUERYBASEURL +
				'Result/get-all-paged' +
				checkReturned(
					returnValue('pageSize=', pageSize) + returnValue('&pageNumber=', pageNumber) + returnValue('&sort=', sort)
				) +
				'&status=pending',
			header: utils.headerNoAuth(),
		},
		actionType: resultType.getAllUnapproved,
	});

export const getApprovedResultsAction = (pageSize?: number, pageNumber?: number, sort?: string) =>
	utils.httpGetMethod({
		apiData: {
			url: '',
			customurl:
				QUERYBASEURL +
				'Result/get-all-paged' +
				checkReturned(
					returnValue('pageSize=', pageSize) + returnValue('&pageNumber=', pageNumber) + returnValue('&sort=', sort)
				) +
				'&status=approved',
			header: utils.headerNoAuth(),
		},
		actionType: resultType.getAllApproved,
	});

export const getRejectedResultsAction = (pageSize?: number, pageNumber?: number, sort?: string) =>
	utils.httpGetMethod({
		apiData: {
			url: '',
			customurl:
				QUERYBASEURL +
				'Result/get-all-paged' +
				checkReturned(
					returnValue('pageSize=', pageSize) + returnValue('&pageNumber=', pageNumber) + returnValue('&sort=', sort)
				) +
				'&status=rejected',
			header: utils.headerNoAuth(),
		},
		actionType: resultType.getAllRejected,
	});

export const getResultByIdAction = (id: string) =>
	utils.httpGetMethod({
		apiData: {
			url: '',
			customurl: QUERYBASEURL + 'Result/' + (id || ''),
			header: utils.headerNoAuth(),
		},
		actionType: resultType.getById,
	});

export const updateResultStatusAction = (data: { id: string; status: 'Approved' | 'Rejected'; comment?: string; otp?: string }) =>
	utils.httpPostMethod({
		apiData: {
			url: '',
			customurl: COMMANDBASEURL + 'Result/update-result_status',
			header: utils.headerAuth(),
			data: JSON.stringify(data),
		},
		actionType: resultType.updateStatus,
	});

export interface IResultDataAction {
	id: string;
	votersOnRegister: number;
	accreditedVoters: number;
	ballotPapersIssuedToPoolingUnit: number;
	unusedBallotPapers: number;
	rejectedBallot: number;
	totalValidVotes: number;
	totalUsedBallotPapers: number;
	updateBy: string;
	comment: string;
}

export const updateResultDataAction = (data: IResultDataAction) =>
	utils.httpPostMethod({
		apiData: {
			url: '',
			customurl: COMMANDBASEURL + 'Result/update-result_data',
			header: utils.headerNoAuth(),
			data: JSON.stringify(data),
		},
		actionType: resultType.updateResultData,
	});

export interface IPartyResultDataAction {
	id: string;
	updateBy: string;
	comment: string;
	partyResults: { partyId: number; partyName: string; votes: number }[];
}

export const updatePartyResultDataAction = (data: IPartyResultDataAction) =>
	utils.httpPostMethod({
		apiData: {
			url: '',
			customurl: COMMANDBASEURL + 'Result/update-party-result_data',
			header: utils.headerNoAuth(),
			data: JSON.stringify(data),
		},
		actionType: resultType.updatePartyResultData,
	});

export const uploadResultDataAction = (
	data: FormData,
	onSuccess?: (res: IUploadFileResponse) => void,
	onFailure?: (res: any) => void
) =>
	utils.httpUploadMediaMethod({
		apiData: {
			url: '',
			customurl: 'https://media-manager-ielect.ngrok.app/api/FileManager/upload-image',
			header: utils.headerMultiPart(),
			data,
		},
		actionType: resultType.uploadResultData,
		onSuccess,
		onFailure,
	});
